import { forwardRef, type ComponentPropsWithRef } from "react";
import { type PropsWithOptionalTestID } from "@boi/components-core";

import * as S from "./RadioBase.styled";

export type RadioBaseProps = PropsWithOptionalTestID &
  Omit<
    ComponentPropsWithRef<"input">,
    "type" | "style" | "className"  | "aria-invalid"
  > & {
    hasError?: boolean;
  };

const RadioBase = forwardRef<HTMLInputElement, RadioBaseProps>((props, ref) => {
  const { hasError, testID = "radio", ...inputProps } = props;

  return (
    <S.CustomRadio $hasError={hasError}>
      <S.HiddenInput
        {...inputProps}
        ref={ref}
        type="radio"
        data-testid={testID}
      />

      <S.CheckedIcon />
    </S.CustomRadio>
  );
});

RadioBase.displayName = "RadioBase";

export default RadioBase;
